"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactIntl = require("react-intl");
var _mobxReact = require("mobx-react");
var _graphql = require("@apollo/client/react/hoc/graphql");
var _lodash = require("lodash");
var _Field = _interopRequireDefault(require("../Field"));
var _FormattedComponents = require("../FormattedComponents");
var _inputUtils = require("../../utils/input-utils");
var _messages = _interopRequireDefault(require("./messages"));
var _mutations = require("../../api/user/mutations");
var _mutationOptions = require("../../api/user/mutation-options");
var _loginErrors = _interopRequireDefault(require("../../login-errors"));
var _posthogUtils = require("../../utils/posthog-utils");
var _posthogEvents = require("../../posthog-events");
var _styles = require("./styles");
var _dec, _dec2, _class; //helpers
//messages
//errors
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var ChangePasswordComponent = (_dec = (0, _mobxReact.inject)('store'), _dec2 = (0, _graphql.graphql)(_mutations.UpdatePassword, _mutationOptions.updatePasswordOptions), _dec(_class = _dec2(_class = (0, _mobxReact.observer)(_class = /*#__PURE__*/function (_Component) {
  function ChangePasswordComponent() {
    var _this;
    _classCallCheck(this, ChangePasswordComponent);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, ChangePasswordComponent, [].concat(args));
    _defineProperty(_this, "changePassword", function (event) {
      event.preventDefault();
      (0, _posthogUtils.posthogCapture)(_posthogEvents.posthogEvents.attemptChangePassword);
      var _this$props = _this.props,
        store = _this$props.store,
        updatePasswordMutation = _this$props.updatePasswordMutation;
      var page = store.changePasswordPage;
      var validatePassword = page.validatePassword;
      validatePassword(updatePasswordMutation, store);
    });
    return _this;
  }
  _inherits(ChangePasswordComponent, _Component);
  return _createClass(ChangePasswordComponent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props2 = this.props,
        formatMessage = _this$props2.intl.formatMessage,
        changePasswordPage = _this$props2.store.changePasswordPage;
      var translations = (0, _lodash.mapValues)((0, _lodash.pick)(_messages["default"], ['changedPassword', 'canNotChangePassword']), function (message) {
        return formatMessage(message);
      });
      changePasswordPage.setTranslations(translations);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
        formatMessage = _this$props3.intl.formatMessage,
        store = _this$props3.store,
        isMobile = _this$props3.isMobile;
      var changePasswordPage = store.changePasswordPage,
        app = store.app;
      var views = app.views;
      var form = changePasswordPage.form,
        passwordsMatch = changePasswordPage.passwordsMatch,
        isValidNewPassword = changePasswordPage.isValidNewPassword,
        showChangePasswordForm = changePasswordPage.showChangePasswordForm,
        errorCode = changePasswordPage.errorCode,
        setIsInputFocused = changePasswordPage.setIsInputFocused,
        isInputFocused = changePasswordPage.isInputFocused;
      var inputStyles = {
        Input: (0, _styles.getHeight)()
      };
      var resetPasswordLink = "".concat(window.location.origin).concat(views.requestResetPassword.path);
      return /*#__PURE__*/_react["default"].createElement(_styles.ChangePasswordForm, {
        isMobile: isMobile
      }, /*#__PURE__*/_react["default"].createElement(_styles.Title, {
        isMobile: isMobile
      }, formatMessage(_messages["default"].title)), showChangePasswordForm && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Field["default"], _extends({
        placeholder: formatMessage(_messages["default"].oldPassword),
        id: "oldPassword",
        type: "password",
        form: form,
        field: 'oldPassword',
        hideError: true,
        withPasswordToggle: true
      }, (0, _inputUtils.bindField)(form, 'oldPassword'), {
        styles: inputStyles
      })), this.renderError() && /*#__PURE__*/_react["default"].createElement(_styles.StyledErrorWrapper, null, /*#__PURE__*/_react["default"].createElement(_styles.StyledErrorIcon, {
        name: 'warning'
      }), /*#__PURE__*/_react["default"].createElement(_styles.ErrorNotification, null, this.renderError())), /*#__PURE__*/_react["default"].createElement(_styles.StyledText, {
        alignText: 'right',
        onClick: function onClick() {
          return (0, _posthogUtils.posthogCapture)(_posthogEvents.posthogEvents.selectForgotPassword);
        }
      }, /*#__PURE__*/_react["default"].createElement(_styles.StyledButtonLink, {
        href: resetPasswordLink,
        target: "_blank"
      }, formatMessage(_messages["default"].forgotYourPassword))), /*#__PURE__*/_react["default"].createElement(_Field["default"], _extends({
        placeholder: formatMessage(_messages["default"].newPassword),
        id: "newPassword",
        type: "password",
        form: form,
        field: 'newPassword',
        hideError: true
      }, (0, _inputUtils.bindField)(form, 'newPassword'), {
        withPasswordToggle: true,
        withPasswordValidation: true,
        onFocus: function onFocus() {
          return setIsInputFocused(true);
        },
        onBlur: function onBlur() {
          return setIsInputFocused(false);
        },
        isInputFocused: isInputFocused,
        styles: inputStyles
      })), !isValidNewPassword && /*#__PURE__*/_react["default"].createElement(_styles.StyledErrorWrapper, null, /*#__PURE__*/_react["default"].createElement(_styles.StyledErrorIcon, {
        name: 'warning'
      }), /*#__PURE__*/_react["default"].createElement(_styles.ErrorNotification, null, formatMessage(_messages["default"].meetAllRequirements))), /*#__PURE__*/_react["default"].createElement(_Field["default"], _extends({
        placeholder: formatMessage(_messages["default"].newPasswordConfirm),
        id: "newPasswordConfirm",
        type: "password",
        form: form,
        field: 'newPasswordConfirm',
        hideError: true
      }, (0, _inputUtils.bindField)(form, 'newPasswordConfirm'), {
        withPasswordToggle: true,
        styles: inputStyles
      })), !passwordsMatch && /*#__PURE__*/_react["default"].createElement(_styles.StyledErrorWrapper, null, /*#__PURE__*/_react["default"].createElement(_styles.StyledErrorIcon, {
        name: 'warning'
      }), /*#__PURE__*/_react["default"].createElement(_styles.ErrorNotification, null, formatMessage(_messages["default"].passwordsDoNotMatch))), /*#__PURE__*/_react["default"].createElement(_styles.StyledButton, {
        isMobile: isMobile,
        disabled: !form.isValid,
        onClick: this.changePassword
      }, formatMessage(_messages["default"].changePassword)), !isMobile && /*#__PURE__*/_react["default"].createElement(_styles.StyledText, null, /*#__PURE__*/_react["default"].createElement(_styles.StyledButtonLink, {
        onClick: function onClick() {
          return window.history.back();
        }
      }, /*#__PURE__*/_react["default"].createElement(_styles.StyledIcon, {
        name: 'arrow-left'
      }), formatMessage(_messages["default"].goBack)))), !showChangePasswordForm && errorCode === _loginErrors["default"].BLOCKED && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, this.renderError() && /*#__PURE__*/_react["default"].createElement(_styles.StyledErrorWrapper, null, /*#__PURE__*/_react["default"].createElement(_styles.StyledErrorIcon, {
        name: 'warning'
      }), /*#__PURE__*/_react["default"].createElement(_styles.ErrorNotification, null, this.renderError()))));
    }
  }, {
    key: "renderError",
    value: function renderError() {
      var store = this.props.store;
      var changePasswordPage = store.changePasswordPage,
        app = store.app;
      var views = app.views;
      var errorCode = changePasswordPage.errorCode,
        errorMessage = changePasswordPage.errorMessage,
        setHasChangePasswordError = changePasswordPage.setHasChangePasswordError;
      var resetPasswordLink = window.location.origin + views.requestResetPassword.path;
      if (!errorCode && !errorMessage) {
        return null;
      }
      var renderedErrorConfig = [{
        shouldRender: errorCode === 'invalid_password' && errorMessage === _loginErrors["default"].INVALID_PASSWORD,
        message: _messages["default"].wrongCurrent
      }, {
        shouldRender: errorCode === _loginErrors["default"].FIFTH_ATTEMPT && errorMessage === _loginErrors["default"].INVALID_PASSWORD,
        message: _messages["default"].wrongCurrent4thTime,
        values: {
          passwordResetLink: /*#__PURE__*/_react["default"].createElement(_styles.StyledLink, {
            href: resetPasswordLink,
            target: "_blank"
          }, /*#__PURE__*/_react["default"].createElement(_FormattedComponents.FormattedMessage, _messages["default"].passwordResetLink))
        }
      }, {
        shouldRender: errorCode === _loginErrors["default"].BLOCKED && errorMessage === _loginErrors["default"].INVALID_PASSWORD,
        message: _messages["default"].wrongCurrent10thTime,
        values: {
          passwordResetLink: /*#__PURE__*/_react["default"].createElement(_styles.StyledLink, {
            href: resetPasswordLink,
            target: "_blank"
          }, /*#__PURE__*/_react["default"].createElement(_FormattedComponents.FormattedMessage, _messages["default"].passwordResetLink))
        }
      }];
      var renderedError = renderedErrorConfig.find(function (element) {
        return element.shouldRender;
      });
      if (renderedError) {
        setHasChangePasswordError(true);
        return /*#__PURE__*/_react["default"].createElement(_FormattedComponents.FormattedMessage, _extends({}, renderedError.message, {
          values: renderedError.values
        }));
      } else {
        setHasChangePasswordError(false);
      }
    }
  }]);
}(_react.Component)) || _class) || _class) || _class);
var _default = exports["default"] = (0, _reactIntl.injectIntl)(ChangePasswordComponent);
//# sourceMappingURL=index.js.map